var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import Accordion from "../Accordion";
import "../../styles/ChooseFormat.css";
import ImageIcon from '@mui/icons-material/Image';
;
var ChooseFormatStep = function (_a) {
    var format = _a.format, onChange = _a.onChange, onNext = _a.onNext, isOpen = _a.isOpen, onToggle = _a.onToggle, isValid = _a.isValid;
    var _b = useState(false), isValidFormat = _b[0], setIsValidFormat = _b[1];
    useEffect(function () {
        setIsValidFormat(format === 'portrait' || format === 'landscape');
    }, [format]);
    function handleSelect(value) {
        if (format === value) {
            onChange('');
        }
        else {
            onChange(value);
        }
    }
    ;
    return (_jsxs(Accordion, __assign({ title: "Escolha o formato", name: "format", step: 1, isOpen: isOpen, onToggle: onToggle, isValid: isValid }, { children: [_jsxs("div", __assign({ className: "format-options" }, { children: [_jsxs("button", __assign({ type: "button", className: "format-option ".concat(format === 'portrait' ? 'selected' : ''), onClick: function () { return handleSelect('portrait'); } }, { children: [_jsx("div", __assign({ className: "label-text" }, { children: "Feed (1080 x 1350)" })), _jsx("div", __assign({ className: "format-box portrait-box" }, { children: _jsx("div", __assign({ className: "position-preview-image preview-icon-horizontal-retrato" }, { children: _jsx(ImageIcon, { style: { fontSize: 70, color: 'rgb(108,108,108)' } }) })) }))] })), _jsxs("button", __assign({ type: "button", className: "format-option ".concat(format === 'landscape' ? 'selected' : ''), onClick: function () { return handleSelect('landscape'); } }, { children: [_jsx("div", __assign({ className: "label-text" }, { children: "Story (1080 x 1920)" })), _jsx("div", __assign({ className: "format-box landscape-box" }, { children: _jsx("div", __assign({ className: "position-preview-image preview-icon-horizontal-retrato" }, { children: _jsx(ImageIcon, { style: { fontSize: 70, color: 'rgb(108,108,108)' } }) })) }))] }))] })), _jsx("div", __assign({ className: "step-footer" }, { children: _jsx("button", __assign({ type: "button", className: "continue-button button-with-blue-border", onClick: onNext, disabled: !isValidFormat }, { children: "Continuar" })) }))] })));
};
export default ChooseFormatStep;
